import { Button, Flex, Popconfirm } from "antd"
import type { UploadedResource } from "~/common/media/uploadedResources"
import { DownloadButton } from "~/components/DownloadButton"
import { Text } from "~/components/Text"
import { VideoPreview } from "~/components/VideoPreview"
import styles from "./index.css"

type VideoResourceCardProps = {
  resource: UploadedResource
  showVideoPreview: boolean
  videoPreviewRange?: { start: number; end: number }
  onRemove: () => void
}

const formatResourceSize = (size?: number) => {
  if (typeof size !== "number" || !Number.isFinite(size) || size < 0) return ""

  const megabytes = size / (1024 * 1024)
  return `${Number.isInteger(megabytes) ? megabytes : megabytes.toFixed(1)}MB`
}

const getResourceNameFromUrl = (url: string) => {
  try {
    const pathname = new URL(url).pathname
    const filename = pathname.split("/").at(-1)

    return filename ? decodeURIComponent(filename) : "视频文件.mp4"
  } catch {
    return "视频文件.mp4"
  }
}

export const VideoResourceCard = ({
  resource,
  showVideoPreview,
  videoPreviewRange,
  onRemove,
}: VideoResourceCardProps) => {
  return (
    <Flex
      className={styles.videoPreviewCard}
      gap={8}
      vertical
    >
      <Flex
        align="flex-start"
        justify="space-between"
        gap={12}
      >
        <Flex
          vertical
          style={{ width: 0, flex: 1 }}
        >
          <Text ellipsis={{ tooltip: true }}>
            {resource.name || getResourceNameFromUrl(resource.url)}
          </Text>
          <Text
            size="s"
            type="secondary"
          >
            {[
              resource.type?.includes("/") ? resource.type : "video/mp4",
              formatResourceSize(resource.size),
            ]
              .filter(Boolean)
              .join(" · ")}
          </Text>
        </Flex>
        <Flex
          gap={8}
          align="center"
        >
          <DownloadButton
            size="small"
            icon={null}
            url={resource.url}
            kind="video"
            label="下载"
            prefix="上传视频"
          />
          <Popconfirm
            cancelText="取消"
            okButtonProps={{ danger: true }}
            okText="移除"
            placement="top"
            title="确认移除该资源吗？"
            onConfirm={() => onRemove()}
          >
            <Button size="small">移除</Button>
          </Popconfirm>
        </Flex>
      </Flex>
      {showVideoPreview ? (
        <VideoPreview
          startTime={videoPreviewRange?.start}
          endTime={videoPreviewRange?.end}
          className={styles.videoResourcePreview}
          src={resource.url}
        />
      ) : null}
    </Flex>
  )
}
